import React, { useState, useEffect } from 'react';
import { makeStyles, withStyles } from '@material-ui/core/styles';
import { Form } from 'react-final-form';
import {
    TextField,
    Checkboxes,
    Radios,
    Select,
    DatePicker,
    TimePicker,
    Autocomplete,
    Switches
} from 'mui-rff';
import {
    Dialog,
    DialogTitle,
    DialogContent,
    IconButton,
    DialogActions,
    Button,
    InputAdornment,
    Grid
} from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';

const useStyles = makeStyles(() => ({

    brV1: {
        borderRadius: '8px !important'
    },
    widthV1: {
        width: 420,
        maxWidth: 420,
        minWidth: 420
    },
    dialogActionV1: {
        paddingTop: '20px !important',
        paddingBottom: '20px !important',
        paddingLeft: '30px !important',
        paddingRight: '30px !important',
        display: 'flex',
        justifyContent: 'flex-end'
    },
    closeButtonV1: {
        borderRadius: 4,
        boxShadow: '0 1px 1px 0 rgba(22, 29, 37, 0.05), inset 0 2px 0 0 rgba(255, 255, 255, 0.05) !important',
        border: 'solid 1px #d8dce6',
        background: 'linear-gradient(to top, #f6f7f9, #ffffff) !important',
        textTransform: 'capitalize',
        paddingTop: '8px !important',
        paddingBottom: '8px !important',
        paddingLeft: '20px !important',
        paddingRight: '20px !important',
        fontWeight: 600,
        '&:hover': {
            background: 'linear-gradient(to top, #f6f7f9, #ffffff) !important'
        }
    },
    confirmButtonV1: {
        borderRadius: '4px !important',
        backgroundColor: '#09101e !important',
        paddingTop: '8px !important',
        paddingBottom: '8px !important',
        paddingLeft: '24px !important',
        paddingRight: '24px !important',
        textTransform: 'capitalize',
        color: 'white !important',
        fontWeight: 600,
        marginLeft: 16,
        '&:hover': {
            backgroundColor: '#09101e !important'
        }
    },
    confirmButtonDisabled: {
        borderRadius: '4px !important',
        backgroundColor: '#dadada !important',
        paddingTop: '8px !important',
        paddingBottom: '8px !important',
        paddingLeft: '24px !important',
        paddingRight: '24px !important',
        textTransform: 'capitalize',
        color: '#5e636c !important',
        fontWeight: 600,
        marginLeft: 16
    },
    dialogContentV1: {
        paddingLeft: 30,
        paddingRight: 30,
        paddingTop: 24,
        paddingBottom: '32px !important',
        backgroundColor: '#f6f6f8'
    },
    titleV3: {
        color: 'rgba(11, 19, 35, 0.75)',
        fontWeight: 600
    },
    mtV1: {
        marginTop: 4
    },
    divAlign: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        width: '100%'
    },
    titleV1: {
        fontSize: 20,
        color: '#0b1323',
        fontWeight: 'bold'
    },
    closeIcon: {
        color: '#D5D6D9',
        fontSize: 24
    },
    textFieldV1: {
        '& .MuiOutlinedInput-root': {
            backgroundColor: 'white',
            color: '#0b1323'
        }
    },

}));

const EnterDaysDialog = ({ open, onClose, onConfirm }) => {

    let submit;

    const [dialogOpen, setDialogOpen] = useState(open);
    const [daysValue, setDaysValue] = useState("");
    const [confirmDisabled, setConfirmDisabled] = useState(false);

    const classes = useStyles();

    const initialValues = {
        days: daysValue
    }

    const handleClose = () => {
        setDialogOpen(false);
        onClose();
    }

    const getFormFields = (values) => {
        return [
            {
                size: 12,
                visible: true,
                field: (
                    <>
                        <div className={classes.titleV3}>Due In</div>
                        <TextField
                            placeholder="Enter Days"
                            name="days"
                            variant="outlined"
                            size="small"
                            onChange={(e) => setDaysValue(e.target.value)}
                            InputProps={{
                                endAdornment: <InputAdornment position="start">Days</InputAdornment>
                            }}
                            className={classes.mtV1}
                            classes={{ root: classes.textFieldV1 }}
                        />
                    </>
                )
            }
        ]
    }

    const validate = values => {

        const errors = {};

        if (values && !values.days) {
            errors.days = "Please enter days."
        }

        if (values && values.days > 365) {
            errors.days = "Number of days cannot exceed 365"
        }


        if (errors && Object.keys(errors).length !== 0 && errors.constructor === Object) {
            setConfirmDisabled(true);
        } else {
            setConfirmDisabled(false);
        }

        return errors;

    }

    const onSubmit = async values => {
        onConfirm(values.days);
        setDialogOpen(false);
    }

    return (
        <>
            <Dialog
                open={dialogOpen}
                maxWidth='xs'
                onClose={handleClose}
                disableEscapeKeyDown={true}
                disableBackdropClick={true}
                classes={{ paperScrollPaper: classes.brV1, paperWidthXs: classes.widthV1 }}
            >

                <DialogTitle className={classes.dialogTitleV1}>
                    <div className={classes.divAlign}>
                        <div className={classes.titleV1}>Enter No of Days</div>
                        <div>
                            <IconButton onClick={handleClose}>
                                <CloseIcon className={classes.closeIcon} />
                            </IconButton>
                        </div>
                    </div>
                </DialogTitle>

                <DialogContent dividers className={classes.dialogContentV1}>
                    <div>
                        <Form
                            onSubmit={onSubmit}
                            keepDirtyOnReinitialize
                            initialValues={initialValues}
                            validate={validate}
                            id="myForm"
                            render={({ handleSubmit, form, submitting, pristine, values }) => {
                                submit = handleSubmit
                                return (
                                    <form onSubmit={handleSubmit} noValidate id="myForm">
                                        <Grid container alignItems="flex-start">
                                            {getFormFields(values).map((item, idx) => item.visible ? (
                                                <Grid item xs={item.size} key={idx}>
                                                    {item.field}
                                                </Grid>
                                            ) : null)}
                                        </Grid>
                                    </form>
                                )
                            }}
                        />
                    </div>
                </DialogContent>

                <DialogActions className={classes.dialogActionV1}>
                    <div>
                        <Button variant="contained" className={classes.closeButtonV1} onClick={handleClose} >
                            Close
                        </Button>
                        <Button variant="contained" disabled={confirmDisabled} className={classes.confirmButtonV1} classes={{ disabled: classes.confirmButtonDisabled }}
                            onClick={event => {
                                submit(event)
                            }}
                        >
                            Confirm
                        </Button>
                    </div>
                </DialogActions>

            </Dialog>
        </>
    )
}

export default EnterDaysDialog;